// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Nzq5U","name":"styles_name__2FU_m","phone":"styles_phone__swuhG"};